import { createAction, PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '../utils';
import { RESET_STATE_ACTION } from '../types';
import { AddonsState, initialAddonsState } from './types';

const addonsSlice = createSlice({
  name: 'addons',
  initialState: initialAddonsState,
  reducers: {
    getAddons(state: AddonsState): void {
      state.isAddonsLoading = true;
    },
    setAvailableAddons(state: AddonsState, action: PayloadAction<AddonsState['availableAddons']>): void {
      state.isAddonsLoading = false;
      state.availableAddons = action.payload;
    },
    setIsAddonsError(state: AddonsState, action: PayloadAction<boolean>): void {
      state.isAddonsError = action.payload;
      state.isAddonsLoading = false;
    },
    setIsAddonsLoading(state: AddonsState, action: PayloadAction<boolean>): void {
      state.isAddonsLoading = action.payload;
    },
    setLoadingAddonId(state: AddonsState, action: PayloadAction<string | null>): void {
      state.loadingAddonId = action.payload;
    },
    toggleAddon(state: AddonsState, action: PayloadAction<{ id: string; selected: boolean }>): void {
      const { id, selected } = action.payload;

      const isGroupAddon = state.availableAddons?.addOnGroup?.addOns?.some((addon) => addon?.id === id);

      if (isGroupAddon) {
        state.availableAddons?.addOnGroup?.addOns?.forEach((addon) => {
          if (addon) {
            addon.selected = addon.id === id && selected;
          }
        });
      }

      state.availableAddons?.addOns?.forEach((addon) => {
        if (addon.id === id) {
          addon.selected = selected; // Toggle state for standalone add-ons
        }
      });
    },
    setAddonIdForRemoval(state: AddonsState, action: PayloadAction<string>): void {
      state.addonIdToRemove = action.payload;
    },
    setAddonIdToUpsert(state: AddonsState, action: PayloadAction<string>): void {
      state.addonIdToUpsert = action.payload;
    },
    removeAddonIdToUpsert(state: AddonsState, action: PayloadAction<string>): void {
      if (state.addonIdToUpsert === action.payload) {
        state.addonIdToUpsert = null;
      }
    },
    clearAddonIdToUpsert(state: AddonsState): void {
      state.addonIdToUpsert = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): AddonsState => initialAddonsState);
  },
});

const resetState = createAction(RESET_STATE_ACTION.type);

export const { actions: addonActions, reducer: addonsReducer, name: addonKey } = addonsSlice;
